import { intersection, not, union } from '../../../../utility/arrayUtils'

export const getGroupById = (
  res,
  table_context,
  table_config_context,
  tableFieldTemplateId,
  activityType
) => {
  const config = res.find((it) => {
    return (
      it.table_context === table_context &&
      it.table_config_context === table_config_context &&
      it.table_field_template_id === tableFieldTemplateId &&
      it.activity_type === activityType
    )
  })
  if (config) {
    const accumulatedColumn = config.total_by_subfield_template_id
    return { columns: config.subfield_ids, accumulatedColumn }
  } else {
    return { columns: [], accumulatedColumn: null }
  }
}

export const getHiddenId = (
  res,
  table_context,
  table_config_context,
  tableFieldTemplateId,
  activityType
) => {
  const config = res.find((it) => {
    return (
      it.table_context === table_context &&
      it.table_config_context === table_config_context &&
      it.table_field_template_id === tableFieldTemplateId &&
      it.activity_type === activityType
    )
  })
  if (config) {
    return config.subfield_ids
  } else {
    return []
  }
}

export const handleToggle = (value, checked, setChecked) => () => {
  const currentIndex = checked.findIndex((it) => it.path == value.path)
  const newChecked = [...checked]

  if (currentIndex === -1) {
    newChecked.push(value)
  } else {
    newChecked.splice(currentIndex, 1)
  }

  setChecked(newChecked)
}

export const numberOfChecked = (items, checked) => {
  return intersection(checked, items).length
}

export const handleToggleAll = (items, checked, setChecked) => () => {
  if (numberOfChecked(items, checked) === items.length) {
    setChecked(not(checked, items))
  } else {
    setChecked(union(checked, items))
  }
}

const applyParentChildConstraints = (newItem, previouslyAddedItems = []) => {
  // find the min index of all children
  let minIndex = -1
  previouslyAddedItems.forEach((it, index) => {
    if (newItem?.children?.includes(it.path)) {
      /* either index should be less then or minIndex should not -1(default)*/
      if (minIndex >= index || minIndex == -1) {
        minIndex = index
      }
    }
  })
  // splice the array and newItem at min position
  if (minIndex != -1) previouslyAddedItems.splice(minIndex, 0, newItem)
  else previouslyAddedItems.push(newItem)
  // reassign new sequence as index
  const sequencialized = previouslyAddedItems.map((it, index) => ({
    ...it,
    sequence: index,
  }))
  // new sequencialized array
  return sequencialized
}

export const applyParentChildConstraintsOnArray = (data) => {
  let updatedData = []
  data.forEach((it) => {
    updatedData = applyParentChildConstraints(it, updatedData)
  })
  return updatedData
}
